
import React from "react"
import PropTypes from "prop-types"
import { bem } from "../../helpers"
import List from "../List/List"
import BaseField from "./Base";
import objectPath from "object-path"

export class FieldGroup extends BaseField {
  renderWrapper = (props) => {
    const {
      type,
      disabled,
      form,
      name,
      className,
      children
    } = props
      
    return (
      <fieldset 
        form={form}
        name={name}
        disabled={disabled}
        className={bem(
          "group", 
          "", 
          [
            type || this.inputType, 
            this.hasErrors() && "invalid"
          ], 
          className
        )}
      >
        {children}
      </fieldset>
    )
  }

  renderLabel = () => {
    const {
      label
    } = this.props
    if (label){
      return (
        <legend className={bem("group", "label")}><h3>{label}</h3></legend>
      )
    }
  } 
}

FieldGroup.propTypes = {
  ...BaseField.propTypes,
  id: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any.isRequired,
    })
  )
}

export default FieldGroup
